<template>
  <div class="emat-block-item">
    <div class="flex">
      <EmatInfo v-if="info || infoPopup" :info="info" v-bind="infoPopup || {}"/>
      <span class="label" v-if="label" >{{ label }}</span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import EmatInfo from '../../General/Info';

export default {
  name: 'BlockItem',

  components: {
    EmatInfo
  },

  props: {
    label: {
      label: String,
      default: null,
    },
    info: {
      info: String,
      default: null,
    },
    infoPopup: {
      type: Object,
      default: null,
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/abstracts";
.emat-block-item {
  padding: 20px 15px 18px;

  &:nth-child(odd) {
    background-color: var(--c-zebra-stripe);
  }

  &:nth-child(even) {
    background-color: $white;
  }

  .label {
    font-family: var(--font);
    font-size: 14px;
    color: #4D4F5C;
    user-select: none;
  }

  .flex {
    max-height: 16px;
    display: flex;
    flex-direction: row;
    align-content: center;
  }
}
</style>
